// Actions
import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
// Constants
import { StoreEntityStatus } from "@ms/uno-constants/lib/local/StoreConstants";
// Stores
import { EventPublishingStore } from "@ms/uno-fluxcore/lib/local/stores/EventPublishingStore";
import { compositeKeyFromStringArray } from "@ms/uno-utilities/lib/local/StringUtilities";
import { logUnreachableAction } from "../../utilities/LoggingUtilities";
/**
 * Store containing the access tokens and user id information
 */ export class AuthStore extends EventPublishingStore {
    get name() {
        return "AuthStore";
    }
    handleAction(action) {
        let storeChanged = false;
        switch(action.type){
            case ActionType.ClearAccessToken:
                storeChanged = this.handleClearAccessTokenAction(action);
                break;
            case ActionType.FetchAccessTokenSucceeded:
                storeChanged = this.handleFetchAccessTokenSucceededAction(action);
                break;
            case ActionType.FetchAccessToken:
                storeChanged = this.handleFetchAccessTokenAction(action);
                break;
            case ActionType.FetchAccessTokenFailed:
                storeChanged = this.handleFetchAccessTokenFailedAction(action);
                break;
            default:
                logUnreachableAction(this, this.loggers, action);
                return;
        }
        if (storeChanged) {
            this.publishStoreChangedEvent();
        }
    }
    getIdTokenDetails() {
        // TODO PBI 7728460 - implement this
        throw new Error("Method not implemented.");
    }
    /**
     * Get the accessToken currently stored for scopes and claims
     * @param scopes
     * @param claims
     */ getAccessToken(scopes, claims) {
        // TODO Append if we will have multiple tokens for a resource based on claims in future
        if (scopes.length === 0) {
            return {
                data: null,
                status: StoreEntityStatus.Unfetched
            };
        }
        const scopeKey = compositeKeyFromStringArray(scopes);
        const scopeKeyToken = this.scopeKeyToken[scopeKey];
        const scopeKeyTokenExpiry = this.scopeKeyTokenExpiry[scopeKey];
        const status = this.tokenFetchingStatus[scopeKey] ?? StoreEntityStatus.Unfetched;
        if (!scopeKeyToken) {
            return {
                data: null,
                status: status
            };
        }
        return {
            data: {
                accessToken: scopeKeyToken,
                expiry: scopeKeyTokenExpiry
            },
            status: status
        };
    }
    handleFetchAccessTokenSucceededAction(action) {
        // Update the stored Access token for the resource.
        const scopeKey = compositeKeyFromStringArray(action.scopes);
        this.scopeKeyToken[scopeKey] = action.accessToken;
        this.scopeKeyTokenExpiry[scopeKey] = action.expiry;
        // Update status
        this.tokenFetchingStatus[scopeKey] = StoreEntityStatus.Present;
        return true;
    }
    handleFetchAccessTokenAction(action) {
        const scopeKey = compositeKeyFromStringArray(action.scopes);
        if (this.tokenFetchingStatus[scopeKey] === StoreEntityStatus.Fetching) {
            return false;
        }
        this.tokenFetchingStatus[scopeKey] = StoreEntityStatus.Fetching;
        return true;
    }
    handleFetchAccessTokenFailedAction(action) {
        const scopeKey = compositeKeyFromStringArray(action.scopes);
        if (this.tokenFetchingStatus[scopeKey] === StoreEntityStatus.UnableToFetch) {
            return false;
        }
        this.tokenFetchingStatus[scopeKey] = StoreEntityStatus.UnableToFetch;
        return true;
    }
    handleClearAccessTokenAction(action) {
        const scopeKey = compositeKeyFromStringArray(action.scopes);
        const storeCopy = this.scopeKeyToken[scopeKey];
        const storeStatus = this.tokenFetchingStatus[scopeKey];
        if (storeCopy == null || storeStatus === StoreEntityStatus.Unfetched) {
            return false;
        }
        // Clear cached token if any
        delete this.scopeKeyToken[scopeKey];
        delete this.scopeKeyTokenExpiry[scopeKey];
        this.tokenFetchingStatus[scopeKey] = StoreEntityStatus.Unfetched;
        return true;
    }
    constructor(loggers){
        super(), this.loggers = loggers, this.scopeKeyToken = {}, this.scopeKeyTokenExpiry = {}, this.tokenFetchingStatus = {};
    }
}
